import { apiSlice } from "./apiSlice";
import config from "../../config.json";

export const reportApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loadComplianceReport: builder.query({
      query: (id) => (config.GetComplianceReport || "") + id,
      providesTags: ["ComplianceReport"],
    }),
    loadMonthlyPayCandidates: builder.query({
      query: ({ id, type }) => (config.GetCandidatePayReport || "") + id + "&type=" + type,
      providesTags: ["MonthlyPayCandidates"],
    }),
  }),
});

export const {
  useLoadComplianceReportQuery,
  useLazyLoadComplianceReportQuery,
  useLoadMonthlyPayCandidatesQuery,
  useLazyLoadMonthlyPayCandidatesQuery,
} = reportApiSlice;
